export const denominations = [
    {
        "id": 1,
        "name": "The Free Pentecoste Church of Tanzania (FPCT)",
        "image": "https://fpct.or.tz/wp-content/uploads/2026/06/fpct-logo-transparenT-1.png",
        "address": "P.O. Box 12251 Dar es Salaam",
        "bishop": "Ask. Stevie Mlenga",
        "email": "mulengastev@yahoo.com",
        "phone": "0755 664 009 | 0689 738008"
    },
    {
        "id": 2,
        "name": "Pentecoste Assemblies of God (PAG)",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSDzBhpHMkT0cheyYIl6fxCEscG-wWJBUBWYg&s",
        "address": "P.O. Box 3390 Dodoma",
        "bishop": "Ask. Daniel Awet",
        "email": "dawetbifa@yahoo.com, danielalley@",
        "phone": "0754 376483 | 0742 077770"
    },
    {
        "id": 3,
        "name": "Naioth Gospel Assembly (NGA)",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTujkQW8ml1GrtekBRFHjC9ChHUGnhKjfd3Bg&s",
        "address": "P.O. Box 62535 Dar es Salaam",
        "bishop": "Ask. David Mwasota",
        "email": "mwasotadavid@yahoo.com",
        "phone": "0713 417427 | 0786 417427 | 0758 417427"
    },
    {
        "id": 4,
        "name": "Tabernacle Gospel Church",
        "image": null,
        "address": "P.O. Box 2198 Arusha",
        "bishop": "Ask. Joseph Shee",
        "email": "josephshee2001@yahoo.com",
        "phone": "0754 986790"
    },
    {
        "id": 5,
        "name": "United Africa Fellowship Church – UAFC",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT11B5zXsLG6eI6xFNKBz_dT0pKtDyFm9TXrQ&s",
        "address": "P.O. Box 952 Iringa",
        "bishop": "Ask. Elia Mwakasungula",
        "email": "eliamwakasungula@yahoo.com, timoth.nzumbi@gmail.com",
        "phone": "0753 694460"
    },
    {
        "id": 6,
        "name": "Pentecostal Gospel Centre Churches and Mission (PGCCM)",
        "image": null,
        "address": "P.O. Box Dar es Salaam",
        "bishop": "Mch. Abdiel Mbise",
        "email": "alphonselim@gmail.com",
        "phone": "0782 139599"
    },
    {
        "id": 7,
        "name": "Tanzania Assemblies of God (TAG)",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSIIapugtLqHLV4zhpJ_1oDhxF4sDOdQ9LdYA&s",
        "address": "",
        "bishop": "Ask Barnabas Mtokambali",
        "email": "bmtokambali@yahoo.com, tagheadquarter@gmail.com",
        "phone": "0754 886944 | 0655 886944"
    },
    {
        "id": 8,
        "name": "Pentecost Holiness Mission (PHM)",
        "image": "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhnxnV6yIgVHuiavQ9FUrfcCRwe66h5mTIlF0qpsUPo7lyl6P9wgf6AXVsgvf5JyzHNClkyqmjbVFT73Cw9-WIuu6iSkSHyl5rZYAtZOgoOxlZ1psZk_bwtf2RBEgPPpOrhE9VKuKTymQw/s1600/logo+phm.png",
        "address": "P.O. Box 67504 Dar es Salaam",
        "bishop": "Mch. Dickson S. Mbwambo",
        "email": "",
        "phone": "0714 774329"
    },
    {
        "id": 9,
        "name": "Pentecost Church of God in Tanzania (PCGT)",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSLXNAHB813_rBk6bBtfprdLP378L09VY-Abg&s",
        "address": "P.O. Box 42263 Dar es Salaam",
        "bishop": "Ask. Anyimike G. Mwakalasya",
        "email": "bpmwakalashia@yahoo.com, mary_mwakajinga@yahoo.com, pkasyanju@yahoo.com",
        "phone": "0754 624756"
    },
    {
        "id": 10,
        "name": "Christ co-workers Fellowship",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQebUinfJOBM3uv7RifEWJiM-8MmZDYz9m8vw&s",
        "address": "P.O. Box Dar es Salaam",
        "bishop": "Ask. Philidon Siyame",
        "email": "chriscotz@yahoo.com",
        "phone": "0782 434864"
    },
    {
        "id": 11,
        "name": "Church of God of Prophecy",
        "image": "https://dq5pwpg1q8ru0.cloudfront.net/2020/10/30/07/46/26/67ff8349-ea9a-4ef0-8552-0e4a53f84261/4foznxbl87_LOGO_4download.jpg",
        "address": "P.O. Box 70562 Dar es Salaam",
        "bishop": "Ask. Erick Mwambigija",
        "email": "emwambigija@hotmail.com, emwambigija@yahoo.co.uk",
        "phone": "0754 888828"
    },
    {
        "id": 12,
        "name": "Calvary Assemblies of God",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRI45vzHDU0OsdUBdAMCVpWUgL6jbFur8opBA&s",
        "address": "P.O. Box 3143 Morogoro",
        "bishop": "Ask. Dastan Maboya",
        "email": "dmaboya@yahoo.com",
        "phone": "0755 301743 | 0766 266786"
    },
    {
        "id": 13,
        "name": "Christian Life Church",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTVSbDOyowj30nBZcFvcqsubW_tFGwyD5_xnQ&s",
        "address": "P.O. Box 60113 Dar es Salaam",
        "bishop": "Ask. Joseph Laizer",
        "email": "peterlukindo@hotmail.com, clctz@yahoo.com",
        "phone": "0769 421556"
    },
    {
        "id": 14,
        "name": "Pentecost holiness Association Mission Tanzania",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRjNpfMgaF4_vxrdjJmwRLWLPXLa7qTI0Hj3g&s",
        "address": "P.O. Box 288 Dar es Salaam",
        "bishop": "Ask. Andrew Mbwilo",
        "email": "",
        "phone": "0766 735474"
    },
    {
        "id": 15,
        "name": "Hebrews Camp For All Nations",
        "image": null,
        "address": "P.O. Box 2138 Mwanza",
        "bishop": "Ask. Lameck K. Maguluchini",
        "email": "hebrewstz@gmail.com",
        "phone": "0768 010241 | 0787 010241 | 0685 010241"
    },
    {
        "id": 16,
        "name": "Faith Community Pentecost Church",
        "image": null,
        "address": "P.O. Box 4930 Dar es Salaam",
        "bishop": "Ask. Bathromew Sheggah",
        "email": "bsheggh@yahoo.com; nag mail faithocto20@gmail.com; sheggahb@yahoo.co.uk",
        "phone": "0713 606224 | 0747 706371"
    },
    {
        "id": 17,
        "name": "Tanzania Youth Ministries",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS9oGCrZp6ZzBIZt3ilVx_3PolQNtjeWOErvA&s",
        "address": "P.O. Box 1280 Morogoro",
        "bishop": "Suleman Kulwa Sweke",
        "email": "atayomi@gmail.com, sweke@yahoo.com",
        "phone": "0754 020402"
    },
    {
        "id": 18,
        "name": "International Evangelism Church",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR6d1hsaoYT0jm2qaW7dNf8CaY2PniCEGZsug&s",
        "address": "P.O. Box 6014 Arusha",
        "bishop": "Ask. Eliud Isangya",
        "email": "sakila25@gmail.com",
        "phone": "0754 383611 | +1360-517-3648"
    },
    {
        "id": 19,
        "name": "Philadephia Gospel Assembly",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQtJMS_FRgBmBp9_YpgsAceLlPk2KTH31GW3w&s",
        "address": "P.O. Box 331 Dodoma",
        "bishop": "Ask. Dr. Yohana Masinga",
        "email": "ymasinga@yahoo.com, hq@pgatz.org",
        "phone": "0757 456410 | 0784 838101"
    },
    {
        "id": 20,
        "name": "Tanzania Missionaries Revival Church",
        "image": null,
        "address": "P.O. Box 2241 Mwanza",
        "bishop": "Mch. Emmanuel Kilusungu",
        "email": "jkisandu@yahoo.com",
        "phone": "0754 540311"
    },
    {
        "id": 21,
        "name": "Voice of Salvation & Healing Church",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS8lFnQ4V_mWBwTG19A4vzEiEGcrL8OgsC-Sw&s",
        "address": "P.O. Box 219 Musoma",
        "bishop": "Ask. Joseph Mtatilo",
        "email": "voshchurchtz@yahoo.com",
        "phone": "0756 306223"
    },
    {
        "id": 22,
        "name": "Deliverance Assemblies of God",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSU8bppe_DMZSdfR7ECLCUdVIXsGPVWo0qCqg&s",
        "address": "P.O. Box 31275 Dar es Salaam",
        "bishop": "Ask. Germanus Lyengi",
        "email": "germanuslyengi30@yahoo.com",
        "phone": "0755 525923 | 0755 653187"
    },
    {
        "id": 23,
        "name": "Bethany Christian Church",
        "image": null,
        "address": "P.O. Box 5612 Tanga",
        "bishop": "Ask. Joshua Issazi",
        "email": "issazijoshua@yahoo.com, henrymathayo@yahoo.com",
        "phone": "0714 863801"
    },
    {
        "id": 24,
        "name": "Faith Church & Mission",
        "image": null,
        "address": "P.O. Box 13196 Dar es Salaam",
        "bishop": "Ask. Ezekiel Ngimbuzi",
        "email": "enangi1965@yahoo.com",
        "phone": "0755 004168"
    },
    {
        "id": 25,
        "name": "Church of God in Tanzania",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQyVivpv7ftMR-tAD-GD_Y575I5bk4qOIOHdA&s",
        "address": "P.O. Box 70202 Dar es Salaam",
        "bishop": "Ask. Timotheo Lutobola",
        "email": "lutobolatimotheo@gmail.com",
        "phone": "0757 177960 | 0657 125127"
    },
    {
        "id": 26,
        "name": "Elim Pentekoste",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ1lpm6Ul10e2RpOxuhX22Irj9Aaz6wFh-AKg&s",
        "address": "P.O. Box 1516 Tanga",
        "bishop": "Ask. Peter Lyema Konki",
        "email": "nathanpeter2002@yahoo.com",
        "phone": "0786 503272 | 0695 246700"
    },
    {
        "id": 27,
        "name": "Tabernacle Gospel International Church",
        "image": null,
        "address": "P.O. Box 11132 Mwanza",
        "bishop": "Ask. Veronica M. Lwakisumbwa",
        "email": "alwakisumbwa@yahoo.com",
        "phone": "0754 089256"
    },
    {
        "id": 28,
        "name": "Gospel Assembly Mission Tanzania",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTQQ-8F8Uk3-fi6igeUfE_HYWxeONn0A17k9g&s",
        "address": "P.O. Box 8251 Dar es Salaam",
        "bishop": "Ask. Wiliam Mboya",
        "email": "mboyasr@yahoo.com",
        "phone": "0754 000026"
    },
    {
        "id": 29,
        "name": "Zion Gospel Assembly",
        "image": "https://yt3.googleusercontent.com/_kPFtIH168wYN6klWDacWXKUdNiyQBgJv21keUAyZtTqNikYLh492TSMQu7Wzy0YRsNOIrFAZw=s900-c-k-c0x00ffffff-no-rj",
        "address": "P.O. Box 69 Shinyanga",
        "bishop": "Ask. Elinywesya Mpule",
        "email": "zionchurchhq@gmail.com, maalimlazaro@yahoo.com",
        "phone": "0763 187898"
    },
    {
        "id": 30,
        "name": "Redeemed Gospel Church",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTvT2V1Am49N30Rw_12HjMJEP1INJLbidyR1g&s",
        "address": "P.O. Box 55667 Dar es Salaam",
        "bishop": "Charles Kiyengo",
        "email": "alukama93@yahoo.com, alukama93@gmail.com",
        "phone": "0655 847574 | 0719 237384"
    },
    {
        "id": 31,
        "name": "Redeemed Assemblies of God",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOSXmqsQCkesnet6l4v50bH-TWzDhsJKWpCQ&s",
        "address": "P.O. Box 11457 Dodoma",
        "bishop": "Ask. Simon Silwimba",
        "email": "rag_tz_church@yahoo.com, davidsilwimba@yahoo.com",
        "phone": "0755 696567 | 0784 127604"
    },
    {
        "id": 32,
        "name": "Mighty Revival Ministry",
        "image": null,
        "address": "P.O. Box 13677 Dar es Salaam",
        "bishop": "Ask. Keneth D. Fungo",
        "email": "revivalmighty@yahoo.com",
        "phone": "0756 365994"
    },
    {
        "id": 33,
        "name": "Tanzania Methodist Church",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcShHIMHkJPqRTmpm46Elsf92SaMfvQogFkweA&s",
        "address": "P.O. Box 60586 Dar es Salaam",
        "bishop": "Askofu Mkuu",
        "email": "bundalatmc69@gmail.com",
        "phone": ""
    },
    {
        "id": 34,
        "name": "Hope For All Nations Ministries (HOFAN)",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSjWleqEPD7u7cNEsshvGxM0n7YM58vzNh0CA&s",
        "address": "P.O. Box 70433 Dar es Salaam",
        "bishop": "Ask. Charles Jangala",
        "email": "jangalacharles@hotmail.com",
        "phone": "0756 346958 | 0756 499999"
    },
    {
        "id": 35,
        "name": "Agape Life Church",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRN6YBikZ0qZjGb_dEZk9Ayv9hC_wgyfVapCg&s",
        "address": "P.O. Box 70029 Dar es Salaam",
        "bishop": "Ask. Vernon Fernandes",
        "email": "info@agape.co.tz, doxaglory@gmail.com, agapetv@simbante.net",
        "phone": "0655 387007"
    },
    {
        "id": 36,
        "name": "Maranatha Christian Church",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTECkUaj2FeQItwlk_f49o6meie5wPkPObVeg&s",
        "address": "P.O. Box 863 Arusha",
        "bishop": "Ask. Erick Mukwenda",
        "email": "pastorericm@yahoo.com, laizern@yahoo.com",
        "phone": "0769 081076"
    },
    {
        "id": 37,
        "name": "Pentecost Moto Moto",
        "image": null,
        "address": "P.O. Box 148 Kigoma",
        "bishop": "Ask. Ezra Mtamya",
        "email": "emtamya@gmail.com, eliasaph.mathew@gmail.com",
        "phone": "0759 749636"
    },
    {
        "id": 38,
        "name": "Pentecostal Gospel Center Churches & Mission",
        "image": null,
        "address": "P.O. Box 11896 Arusha",
        "bishop": "Ask. Alphonce N. Limo",
        "email": "pgccmission@gmail.com",
        "phone": "0786 067219"
    },
    {
        "id": 39,
        "name": "Evangelistic Assemblies of God Tanzania (EAGT)",
        "image": "https://ncg.home.blog/wp-content/uploads/2019/09/eagt-logo.png?w=640",
        "address": "P.O. Box 1489 Dodoma",
        "bishop": "Rev. Brown Mwakipesile",
        "email": "mlimwaeagt@yahoo.com, mwizarubi2006@yahoo.com",
        "phone": "0754 267748"
    },
    {
        "id": 40,
        "name": "Jesus Healing Miracle Gospel Church & Ministry",
        "image": null,
        "address": "P.O. Box 13190 Arusha",
        "bishop": "Ask. Dastan Mwoleka",
        "email": "jesusthehealerhq@yahoo.com",
        "phone": "0754 963418"
    },
    {
        "id": 41,
        "name": "Tanzania Field Evangelism",
        "image": null,
        "address": "P.O. Box 1301 Mwanza",
        "bishop": "Ask. Augustine Mpemba",
        "email": "ampemba7@yahoo.com",
        "phone": "0754 435861"
    },
    {
        "id": 42,
        "name": "Pentecost of Africa Mission Church",
        "image": null,
        "address": "",
        "bishop": "Ask. Godfrey Pallangyo",
        "email": "kisalishari@yahoo.co.uk",
        "phone": "0762 616355 | 0784 466218"
    },
    {
        "id": 43,
        "name": "International Christian Ministries I.C.M",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT1p_O3J3uQee1ztBuOozQhTCm6usUDaMbtFQ&s",
        "address": "",
        "bishop": "Ask. Tryphone Rutaihwa",
        "email": "rutaihwat@yahoo.com",
        "phone": "0752 195398"
    },
    {
        "id": 44,
        "name": "The Oasis of Healing Ministry",
        "image": null,
        "address": "P.O. Box 72635 Dar es Salaam",
        "bishop": "Ask. Prosper Ntepa",
        "email": "prosperkasesela@gmail.com",
        "phone": "0713 212440 | 0715 997914"
    },
    {
        "id": 45,
        "name": "Huduma ya Nuru ya Maombi na Maombezi",
        "image": null,
        "address": "P.O. Box 55195 Dar es Salaam",
        "bishop": "Ask. Lilian Tarimo",
        "email": "",
        "phone": "0784 889327 | 0655 889327"
    },
    {
        "id": 46,
        "name": "Sinai Mission International",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ1qNokSVLCyBjmQshpiTTV6QfVHByxfAaCrQ&s",
        "address": "P.O. Box 78022 Dar es Salaam",
        "bishop": "Ask. Edward Kalinga",
        "email": "mountsinaichurchtz@gmail.com",
        "phone": "0692 429336"
    },
    {
        "id": 47,
        "name": "Tanzania Outreach Church",
        "image": null,
        "address": "P.O. Box Dar es Salaam",
        "bishop": "Ask. Elia Suleman",
        "email": "eliasule@yahoo.com, ban.zalo@yahoo.com",
        "phone": ""
    },
    {
        "id": 48,
        "name": "Word Alive Church",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQxMKih96yMf9t9jSHRO-NCfa5M0gBWcCRA2Q&s",
        "address": "P.O. Box Dar es Salaam",
        "bishop": "Ask. Deo Lubara",
        "email": "clubala@yahoo.com, pastormoseswordalive@gmail.com",
        "phone": "0754 461028"
    },
    {
        "id": 49,
        "name": "Naivera Church Apostolic",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQsrmuBo1ST9G6OKNKaQeelp9OK66kJDKsJjQ&s",
        "address": "P.O. Box Arusha",
        "bishop": "Ask. Julius Laizer",
        "email": "laizerj1961@yahoo.com",
        "phone": "0754 386865"
    },
    {
        "id": 50,
        "name": "Pentecostal Revival Church",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRk-TYzTYTZXP7ocVWwAi10x8iMrhQy8fHu-A&s",
        "address": "P.O. Box 3364 Mbeya",
        "bishop": "Ask. Jacob J. Kapesa",
        "email": "",
        "phone": "0755 483096"
    },
    {
        "id": 51,
        "name": "New Harvest Ministries of Tanzania",
        "image": "https://newharvest.org/wp-content/uploads/2020/03/NHMI_Logo-1.png",
        "address": "P.O. Box Katavi",
        "bishop": "Rev. Annastazia K. Laban",
        "email": "newharvetanza@yahoo.com",
        "phone": "0754 237210"
    },
    {
        "id": 52,
        "name": "Union For The Gospel Ministries",
        "image": null,
        "address": "P.O. Box 79732 Dar es Salaam",
        "bishop": "Ask. Nathani Kigwila",
        "email": "ugministry@yahoo.com, johnloleka@gmail.com",
        "phone": "0713 430501 | +1678-559-5223"
    },
    {
        "id": 53,
        "name": "Evangelical Brotherhood Church",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTqKkykLU_jHtGy_M5dTKagCSyK1n8p7hyDhA&s",
        "address": "P.O. Box Mbeya",
        "bishop": "Ask. Labson Mwakanani",
        "email": "rabbimwakanan@gmail.com",
        "phone": "0754 416441 | 0786 999956"
    },
    {
        "id": 54,
        "name": "Huduma ya Damu ya Yesu",
        "image": null,
        "address": "P.O. Box Arusha",
        "bishop": "Ask. Veronical Mrema",
        "email": "veronica.mrema@yahoo.com",
        "phone": "0756 977810"
    },
    {
        "id": 55,
        "name": "Mlimani Graduates Pentecostal Association",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQmiJ_FeYKiIsyhyKSYMZ80omAHtWAb-gB36g&s",
        "address": "P.O. Box 76996 Dar es Salaam",
        "bishop": "Gabriel K. Mafie",
        "email": "mletu2007@yahoo.co.uk",
        "phone": "0783 560197"
    },
    {
        "id": 56,
        "name": "Mission to the World International (MIWOI)",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQMsGbFMCezTTrCJS-HzPNMWH1Muoi1xMrpBw&s",
        "address": "P.O. Box 506 Usa River Arusha",
        "bishop": "Ask. Stephen George Butta",
        "email": "uscimbaseni@yahoo.com",
        "phone": "0786 719233"
    },
    {
        "id": 57,
        "name": "Shepherd’s Staff International Church",
        "image": null,
        "address": "P.O. Box Dar es Salaam",
        "bishop": "Ask. Philemon Kameta",
        "email": "jlilykejo@yahoo.com, proctornxumalo@gmail.com",
        "phone": ""
    },
    {
        "id": 58,
        "name": "Tanzania Gospel Church",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSX89Zf9o4CjRi-WmJXxbkRrYb6OitaGMr3tQ&s",
        "address": "P.O. Box 2681 Morogoro",
        "bishop": "Ask. Robert Mtata",
        "email": "mtatarobert57@gmail.com",
        "phone": "0742 666257 | 0754 532307"
    },
    {
        "id": 59,
        "name": "International Pentecostal Holiness Church – Tanzania",
        "image": "https://upload.wikimedia.org/wikipedia/en/5/5a/International_Pentecostal_Holiness_Church_%28logo%29.jpg",
        "address": "P.O. Box 7331 Dar es Salaam",
        "bishop": "Ask. Berings Mlambya",
        "email": "mlambiah2012@gmail.com",
        "phone": "0754 238955"
    },
    {
        "id": 60,
        "name": "Mission to Unreached Areas Church",
        "image": null,
        "address": "P.O. Box Pwani",
        "bishop": "Ask. Dionisia Meena",
        "email": "meenasamwel1@gmail.com, toureached@yahoo.com",
        "phone": "0754 965412"
    },
    {
        "id": 61,
        "name": "Deeper Christian Life Ministry",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR4u9vcWGnjxMZs6jQGCBJnfdpXbVkYazG8fw&s",
        "address": "P.O. Box Dar es Salaam",
        "bishop": "Ask. Christopher Chovenye",
        "email": "dlbctz@ymail.com",
        "phone": "0759 202838"
    },
    {
        "id": 62,
        "name": "Life Church",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQX7tgpUDZUgaMGD1O4L6QfosSKbM6cAVeFfA&s",
        "address": "P.O. Box 3092 Mwanza",
        "bishop": "Ask. Alpha Mordekai",
        "email": "alphamordekai@yahoo.com",
        "phone": "0787 274338 | 0754 274338"
    },
    {
        "id": 63,
        "name": "The Agape International Pentecoste Church",
        "image": null,
        "address": "P.O. Box Dar es Salaam",
        "bishop": "Ask. Maria S. Ghambi",
        "email": "agapeinternational@gmail.com, kanisaaipc@yahoo.com, marychris2016@yahoo.com",
        "phone": "0768 035677"
    },
    {
        "id": 64,
        "name": "Victory Gospel Assembly Inc",
        "image": null,
        "address": "P.O. Box 2912 Dar es Salaam",
        "bishop": "Ask. Paul Shemsanga",
        "email": "pshems@yahoo.com, vgatprojects2000@yahoo.co.uk, menerdndekeno@yahoo.com",
        "phone": "0652 297358"
    },
    {
        "id": 65,
        "name": "Christ For All Mankind",
        "image": null,
        "address": "P.O. Box Arusha",
        "bishop": "Ask. John K. Kulindwa",
        "email": "johnkulindwa@yahoo.com, johnkulindwa@gmail.com",
        "phone": "0623 816769"
    },
    {
        "id": 66,
        "name": "Miracle Assemblies of God Ministry (MAGM)",
        "image": null,
        "address": "P.O. Box 1550 Singida",
        "bishop": "Ask. John Tesha",
        "email": "tassembliesofgodministry@yahoo.com, johntesha983@yahoo.com, johntesha02@gmail.com",
        "phone": "0754 012102 | 0786 448125"
    },
    {
        "id": 67,
        "name": "Christ Believers Assembly Ministry",
        "image": null,
        "address": "P.O. Box 95644 Dar es Salaam",
        "bishop": "Ask. John N. Rugohe",
        "email": "",
        "phone": "0788 310408"
    },
    {
        "id": 68,
        "name": "ICM Church Tanzania",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSLgbXzM2nk4vxsx2d-DnMxtk7slSp8JcTe-Q&s",
        "address": "P.O. Box 68380 Dar es Salaam",
        "bishop": "Ask. John Alphonce Mushi",
        "email": "icmtrust10@gmail.com",
        "phone": "0715 821515"
    },
    {
        "id": 69,
        "name": "International Evangelical Assemblies of God",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTwyiGqRSanIea5xarH1bc1vVZzHbCBf8yxnA&s",
        "address": "P.O. Box 7240 Shinyanga",
        "bishop": "Ask. David Mabushi",
        "email": "fumbuka61@gmail.com, fumbuka60@gmail.com",
        "phone": "0767 764637"
    },
    {
        "id": 70,
        "name": "Evangelist Spiritual Word Ministry",
        "image": null,
        "address": "",
        "bishop": "Ask. Nasania Amos",
        "email": "evaswommin@gmail.com, amosnassania@gmail.com",
        "phone": "0754 414689"
    },
    {
        "id": 71,
        "name": "Harvest Gospel Church",
        "image": null,
        "address": "P.O. Box 30271 Kibaha Pwani",
        "bishop": "Ask. Emmanuel Mhina",
        "email": "",
        "phone": "0784 325945"
    },
    {
        "id": 72,
        "name": "The Tabernacle Assemblies of God",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSN0wCi3nHIpypMaFzf5ls8ZS3BixF9CXDzPw&s",
        "address": "P.O. Box Dar es Salaam",
        "bishop": "Ask. Yona G. Chimaisi",
        "email": "pastoryona@gmail.com",
        "phone": "0766 221361"
    },
    {
        "id": 73,
        "name": "Restoration Bible Church",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQUG0jjl1-1_AxnldwokxLIQwj2ouDz6G4pew&s",
        "address": "P.O. Box Dar es Salaam",
        "bishop": "Ask. Emmanuel Tumwidike",
        "email": "",
        "phone": "0754 911305"
    },
    {
        "id": 74,
        "name": "Pentekoste Agizo Kuu",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQS9N_mymFfuQiRrUvJqapDZMd93CoKLHTSNQ&s",
        "address": "",
        "bishop": "Ask Damas Mukasa",
        "email": "damasmukasa@gmail.com, damasmukasa@yahoo.com",
        "phone": "0714 972006 | 0753 493097"
    },
    {
        "id": 75,
        "name": "Pentecostal Evangelist Fellowship of Africa (PEFA)",
        "image": "https://play-lh.googleusercontent.com/DJqOM3ffX47_b2p3RN1jhb9YxFfVBj2f4XcyZNZAlvj5fZJKhhZG4FYxbO1nZa2CYQ",
        "address": "P.O. Box Dodoma",
        "bishop": "Ask. Elirehema Molel",
        "email": "elirehemamollel@gmail.com, yothambukombe@gmail.com",
        "phone": "0755 886956"
    },
    {
        "id": 76,
        "name": "Word of Life Pentecost Church of Tanzania",
        "image": null,
        "address": "P.O. Box 14343 Arusha",
        "bishop": "Ask. Yosea Z. Mliga",
        "email": "wordoflifepct20@gmail.com, ymliga2012@gmail.com",
        "phone": "0755 434321"
    },
    {
        "id": 77,
        "name": "Victory faith Ministry Pentecostal Bible Faith Church",
        "image": null,
        "address": "P.O. Box 30481 Kibaha – Pwani",
        "bishop": "Ask. Gervase Martin Masanja",
        "email": "vottanzania@gmail.com",
        "phone": "0754 590926"
    },
    {
        "id": 78,
        "name": "The OAK Mission Ministry",
        "image": "https://i.ytimg.com/vi/EtFF4_Gfv9Q/hqdefault.jpg?sqp=-oaymwEmCOADEOgC8quKqQMa8AEB-AHKAoAC8AGKAgwIABABGGUgZShlMA8=&rs=AOn4CLC87qg1WFU_BFfLSYMmQS4ih2c51Q",
        "address": "S.L.P Kibaha Pwani",
        "bishop": "Ask. Hellen Sogia",
        "email": "sogiahellen@gmail.com, oakmissionhq@gmail.com",
        "phone": "0753 351048"
    },
    {
        "id": 79,
        "name": "Victory Christian Mission Centre",
        "image": null,
        "address": "",
        "bishop": "Ask. Khez-beck Mabesa",
        "email": "petermabesa@yahoo.com",
        "phone": "0676 899775"
    },
    {
        "id": 80,
        "name": "Disciple Nations Pentecost Church",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQADKjln3iUK1bpix4smL8x8czkEpZWtAbQhg&s",
        "address": "S.L.P 1594 Arusha",
        "bishop": "Ask. Somi Severua",
        "email": "skseverua@gmail.com, mjtsuut@gmail.com",
        "phone": "0767 327107"
    },
    {
        "id": 81,
        "name": "Pentecostal Revival Miracle Church",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTV8vEsSSswOBIzdpTh-m1xB2kZ9UySmPkEMQ&s",
        "address": "",
        "bishop": "Ask. Lwagha Njeni",
        "email": "",
        "phone": "0754 323472"
    },
    {
        "id": 82,
        "name": "Bethel World Wide Church",
        "image": null,
        "address": "P.O. Box 13748 Arusha",
        "bishop": "Ask. Pantaleo K. Mushi",
        "email": "pantaleojoseph2003@yahoo.com",
        "phone": "0769 010175"
    },
    {
        "id": 83,
        "name": "Forward in Faith Church International",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRvPekT7Vp96z5KGGLrAAe2MvgqUrq5WT0nJA&s",
        "address": "P.O. Box 72241 Dar es Salaam",
        "bishop": "Ask. Ahaz Haran Tweve",
        "email": "ahaztweve@yahoo.com, shadrackmwalongo@gmail.com",
        "phone": "0757 994118 | 0754 365811"
    },
    {
        "id": 84,
        "name": "Bethel Chapel International",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQtU3tnumHmlXi85L_F7Jbb9nO1p6JKVyWhXA&s",
        "address": "P.O. Box 13934 Dar es Salaam",
        "bishop": "Ask. Denis Kapela",
        "email": "dkapel@yahoo.com",
        "phone": "0755 483096"
    },
    {
        "id": 85,
        "name": "Pentecoste Gospel Mission",
        "image": null,
        "address": "P.O. Box 9833 Dar es Salaam",
        "bishop": "Ask. Barnabas E. Kimbe",
        "email": "pgmission@yahoo.com",
        "phone": "0754 395344 | 0754 059701"
    },
    {
        "id": 86,
        "name": "Healing Ministry of Agape International (HEMA)",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQbXLTL-ghsXlGBSlJ-gSzHd30BLGMiipWTSw&s",
        "address": "P.O. Box 8026 Dar es Salaam",
        "bishop": "",
        "email": "zbonifacewilliam@yahoo.com",
        "phone": ""
    },
    {
        "id": 87,
        "name": "Zion City Church",
        "image": null,
        "address": "P.O. Box 14406 Arusha",
        "bishop": "Ask. Trice Shumbusho",
        "email": "triceshumbusho@gmail.com, info@eastwindministries.org",
        "phone": "0754 020945"
    },
    {
        "id": 88,
        "name": "Emmaus Bible Church",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTs2_8wAQMzW8XmlJb4WOkjpRq4ermtZqnQ4Q&s",
        "address": "P.O. Box 831 Mbeya",
        "bishop": "Mama Askofu Mwakabolo",
        "email": "",
        "phone": "0765 487058"
    },
    {
        "id": 89,
        "name": "The Church of Pentecostal Faith",
        "image": null,
        "address": "P.O. Box 2155 Mbeya",
        "bishop": "Ask. Emmanuel S. Kighalile",
        "email": "simonimmanuel568@gmail.com",
        "phone": "0765 432381"
    },
    {
        "id": 90,
        "name": "Tanzania United Apostolic Faith Church",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSVgtN5tXo2Ig09DmTo-X3Qwkur_pZ-hD9ZjA&s",
        "address": "P.O. Box 317 Kyela Mbeya",
        "bishop": "Ask. Jeston S. Mwanji",
        "email": "mingalusajo@gmail.com",
        "phone": "0743 303663"
    },
    {
        "id": 91,
        "name": "Free Church in Christ (F.C.C)",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTbuXxlszSSHKt0hO9XyovAUruI30vWgDVW1g&s",
        "address": "P.O. Box 5067 Mbeya",
        "bishop": "Ask. Yohana R. Chaula",
        "email": "yohanachaula@gmail.com",
        "phone": "0756 520351"
    },
    {
        "id": 92,
        "name": "Pentecoste Shilo Church",
        "image": null,
        "address": "P.O. Box 2963 Mbeya",
        "bishop": "Ask. Ride Mwakyokile",
        "email": "",
        "phone": "0754 885251"
    },
    {
        "id": 93,
        "name": "Tanzania Calvary Tabernacle Church (T.C.T.C)",
        "image": null,
        "address": "P.O. Box 2073 Mbeya",
        "bishop": "Ask. Anyosisye A. Mwambije",
        "email": "stephenlusako@yahoo.com",
        "phone": "0753 651182"
    },
    {
        "id": 94,
        "name": "Pentecostal Evangelical Fellowship Church",
        "image": null,
        "address": "P.O. Box 1466 Mbeya",
        "bishop": "Ask. Daud S. Sungu",
        "email": "davidsoloko@yahoo.com",
        "phone": "0759 89359 | 0787 410346"
    },
    {
        "id": 95,
        "name": "Great Commission Church of Tanzania",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTeYsajPFfwIY7ziN4tIjVSbsOzHWi_KujeKA&s",
        "address": "P.O. Box 12677 Arusha",
        "bishop": "Ask. Alfred I. Sanga",
        "email": "katulitsa@gmail.com",
        "phone": "0769 501963"
    },
    {
        "id": 96,
        "name": "Pentecostal Renewal Assembly",
        "image": null,
        "address": "P.O. Box 1505 Dodoma",
        "bishop": "Ask. Wilson Mwabhogha",
        "email": "pentecoste_renewal@yahoo.com",
        "phone": "0755 464072"
    },
    {
        "id": 97,
        "name": "The Rock Christian Fellowship",
        "image": null,
        "address": "P.O. Box 109 Mwanza",
        "bishop": "Ask. Joseph Kadaraja",
        "email": "josephkadaraja@gmail.com",
        "phone": "0755 544504"
    },
    {
        "id": 98,
        "name": "The Living Gospel World Mission",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTcNVM1X2Qrbc3CdN0bsD-RvAqFguq8WW7n6w&s",
        "address": "P.O. Box 61090 Dar es Salaam",
        "bishop": "Ask. Rahel Lintu",
        "email": "rdamson2006@yahoo.com",
        "phone": "0713 343920 | 0755 815934"
    },
    {
        "id": 99,
        "name": "All Times Outreach and Training Church (ATOC)",
        "image": null,
        "address": "P.O. Box 75194 Dar es Salaam",
        "bishop": "Ask. Anna F. Zelamula",
        "email": "kanisaatoc@gmail.com",
        "phone": "0672 347178"
    },
    {
        "id": 100,
        "name": "Godliness Pentecostals Church",
        "image": null,
        "address": "P.O. Box 5562 Dar es Salaam",
        "bishop": "Ask. Solomn Kilyoma",
        "email": "solomonkilyoma4@gmail.com",
        "phone": "0713 200341 | 0754 789231"
    },
    {
        "id": 101,
        "name": "New Life in Jesus Christ Church",
        "image": null,
        "address": "P.O. Box 46430 Dar es Salaam",
        "bishop": "Ask. Flora J. Kaguo",
        "email": "fkaguo@gmail.com",
        "phone": "0765 242460"
    },
    {
        "id": 102,
        "name": "Mito ya Baraka Church",
        "image": "https://yt3.googleusercontent.com/xhnGeLzAvcm13QY1s1tEkF3-8g_RoXxYsvR4PxlwLlglRWuW0w54PNO40EHpi7BnwSU_9XeNVQ=s900-c-k-c0x00ffffff-no-rj",
        "address": "P.O. Box 20383 Dar es Salaam",
        "bishop": "Ask. Bruno Mwakibolwa",
        "email": "bbmwakibolwa@gmail.com",
        "phone": "0713 418660 | 0756 270101"
    },
    {
        "id": 103,
        "name": "Huduma ya Uponyaji, Maombi na Mikesha",
        "image": null,
        "address": "P.O. Box 31902 Dar es Salaam",
        "bishop": "Ask. Juliano W. Mbelwa",
        "email": "julianowales@gmail.com",
        "phone": "0754 597024 | 0783 241824"
    },
    {
        "id": 104,
        "name": "Living Water Center",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5bgIqdgd4302J80yGc9gr5c1JNmvWhQpFVQ&s",
        "address": "P.O. Box 10199 Dar es Salaam",
        "bishop": "Ask. Onesmo Ndegi",
        "email": "pmnemwa@gmail.com, onesmondegi@gmail.com, lilyonemo@gmail.com",
        "phone": "0758 155200"
    },
    {
        "id": 105,
        "name": "Tanzania Christian Center Churches",
        "image": null,
        "address": "P.O. Box 14103 Arusha",
        "bishop": "Ask. Polycarp H. Antto",
        "email": "",
        "phone": "0755 748577"
    },
    {
        "id": 106,
        "name": "Evangelical Pentecostal Restoration Church",
        "image": null,
        "address": "P.O. Box 512 Dodoma",
        "bishop": "Ask. Alfred J. Okeyo",
        "email": "ajuma63@gmail.com, mwakalonge@gmail.com",
        "phone": "0767 918475 | 0783 423666"
    },
    {
        "id": 107,
        "name": "Pentecostal Praise Church",
        "image": null,
        "address": "P.O. Box 13376 Arusha",
        "bishop": "Ask. Aminiely E. Mgonja",
        "email": "emgonja@gmail.com",
        "phone": "0754 475019 | 0689 341535"
    },
    {
        "id": 108,
        "name": "Huduma ya Upendo Tanzania Pentecoste",
        "image": null,
        "address": "P.O. Box 105 Ibaba - Ileje",
        "bishop": "Ask. Ibrahimu M. Kibona",
        "email": "",
        "phone": "0754 740798"
    },
    {
        "id": 109,
        "name": "Life and Peace Altar International Church",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTU3VPZKYz7tNECpM39RyHC4IfFsYrSH17O4A&s",
        "address": "P.O. Box 739 Arusha",
        "bishop": "Ask. Elisante I. Cheya",
        "email": "elisantekifaru@gmail.com",
        "phone": "0754 754234 | 0788 675621"
    },
    {
        "id": 110,
        "name": "The Pentecostal Jesus is the Answer Church",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQCoLIv6gCHEh-2BlHWfOqtE5zi2oi7DqblTg&s",
        "address": "P.O. Box 7480 Dar es Salaam",
        "bishop": "Ask. Leonard D. Njau",
        "email": "bishopnjaumemorial@gmail.com",
        "phone": "0653 803091 | 0764 042591"
    },
    {
        "id": 111,
        "name": "WAPO Mission International",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRciXDp9tHjrivQhPXEb0kyDjORM6J0CxZpOQ&s",
        "address": "P.O. Box Dar es Salaam",
        "bishop": "Ask. Sylvesta Gamanya",
        "email": "",
        "phone": "0766 777126 | 0754 073551"
    },
    {
        "id": 112,
        "name": "Full Gospel Bible Fellowship Church",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRno1o1OPdz4Y9M729lguKOxGNVczRYe5DBrw&s",
        "address": "P.O. Box Dar es Salaam",
        "bishop": "Ask. Zacharia Kakobe",
        "email": "",
        "phone": "0755 799135"
    },
    {
        "id": 113,
        "name": "Philadephia Gospel Assembly International",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQtJMS_FRgBmBp9_YpgsAceLlPk2KTH31GW3w&s",
        "address": "P.O. Box 10390 Arusha",
        "bishop": "Ask. Andrew G. Laizer",
        "email": "andrewgama817@gmail.com",
        "phone": "0784 760479 | 0767 660479"
    },
    {
        "id": 114,
        "name": "House of Prayer International Ministries",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSf-9_i-Q8waswvfSRjt6QODCFQJfIIUNIzcQ&s",
        "address": "P.O. Box 336 Tunduma - Songwe",
        "bishop": "Ask. Furaha Mwakabenga",
        "email": "fmwakabenga@gmail.com",
        "phone": "0752 194259"
    },
    {
        "id": 115,
        "name": "Apostolic Church Incorporated of Tanzania",
        "image": null,
        "address": "P.O. Box 3071 Moshi - Kilimanjaro",
        "bishop": "Ask. Daud E. Lun yalula",
        "email": "daudilunyalula1972@gmail.com",
        "phone": "0756 700096 | 0787 500096"
    },
    {
        "id": 116,
        "name": "Amani Kisima cha Makimbilio",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTFMRquWHvLXu-obQmaHefkfNya8VawjLNFRA&s",
        "address": "S.L.P 833 Mbeya",
        "bishop": "Ask. Gilbert A. Kasoba",
        "email": "kasobagilbert@gmail.com",
        "phone": "0765 331998 | 0684 681103 | 0753 504060"
    },
    {
        "id": 117,
        "name": "Yesu ni Lango la Uzima",
        "image": "https://yt3.googleusercontent.com/RQPUSq3103opaBVjvdx6byMmIYRY_my1N5AaohYUszGG0WevU5tjLli7ufWjy1a2ITNZpCvX=s900-c-k-c0x00ffffff-no-rj",
        "address": "P.O. Box 32 Bukombe - Geita",
        "bishop": "Ask. Paul.Daud Ntambi",
        "email": "paulsosela100@gmail.com, yesunilangolauzima255@gmail.com",
        "phone": "0753 052839 | 0752 185026"
    },
    {
        "id": 118,
        "name": "Jesus’s Lord Pentecostal Church",
        "image": null,
        "address": "P.O. Box 2611 Mbeya",
        "bishop": "Ask. Florah R. Mponzi",
        "email": "floramponzi@gmail.com",
        "phone": "0762 968679 | 0657 221760"
    },
    {
        "id": 119,
        "name": "Mji wa Makimbilio Ministry Tanzania",
        "image": null,
        "address": "P.O. Box 131 Handeni - Tanga",
        "bishop": "Ask. Benjamin L. Mdoe",
        "email": "mjiwamakimbilio@gmail.com",
        "phone": "0718 633147 | 0788 404825 | 0769 032580"
    },
    {
        "id": 120,
        "name": "Kanisa la Kristo la Wokovu Kamili Tanzania",
        "image": null,
        "address": "P.O. Box 179 Tuliani - Morogoro",
        "bishop": "Ask. Noel J. Kapeta",
        "email": "kapetanoel1@gmail.com",
        "phone": "0719 744787 | 0762 758158"
    },
    {
        "id": 121,
        "name": "Faith Harvest Church International",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQOjW1NaVtrYtCgHsHpzyBRq2nZIZ1A0WH2dw&s",
        "address": "P.O. Box 567 Mbeya",
        "bishop": "Ask. PhilIp M. Mahali",
        "email": "phlpmahali@gmail.com",
        "phone": "0715 237663 | 0755 237663 | 0766 180166"
    },
    {
        "id": 122,
        "name": "Gospel Healing Church",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSVoCNen1MCxqcRGWlMQgEgELQ0u2AEkC7q9Q&s",
        "address": "P.O. Box 3252 Dar es Salaam",
        "bishop": "Ask. Stansyel .A. Mapamba",
        "email": "gospelandhealing@gmail.com",
        "phone": "0714 437001 | 0762 878571 | 0627 505205"
    },
    {
        "id": 123,
        "name": "Kainos Creation Church",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRspIQ89plB4hUIwzWavpkTiJ6WzE9y632RMA&s",
        "address": "P.O. Box 2166 Nyamagana - Mwanza",
        "bishop": "Ask. Felician Makarios Phos",
        "email": "kcc@kainoscreation.church, kuhanimail@gmail.com",
        "phone": "0742 107009"
    },
    {
        "id": 124,
        "name": "Kings Global Tabernacle Church",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQX141Ho91Pt1QmLjJVIaoWrXxmtZJiolTzhA&s",
        "address": "P.O. Box 2706 Mbeya",
        "bishop": "Ask. Oyi Mwasambili",
        "email": "thekingsglobal@gmail.com, oyimwasambili@gmail.com",
        "phone": "0754 595867"
    },
    {
        "id": 125,
        "name": "Hosanna Pentecostal Church",
        "image": null,
        "address": "P.O. Box 2112 Shinyanga",
        "bishop": "Ask. Julius Kiyuga",
        "email": "hosannapentecostalchurch19@gmail.com, juliuskiyuga@yahoo.com",
        "phone": "0754 754032"
    },
    {
        "id": 126,
        "name": "Victorious Living Church",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTR1BGbvSScg6tt0ZVpSTAeZON9dmiWSBqsHA&s",
        "address": "P.O. Box 41314 Dar es Salaam",
        "bishop": "Ask. John S. Bagenyeka",
        "email": "",
        "phone": "0715 939495"
    },
    {
        "id": 127,
        "name": "CHRIST TO ALL PEOPLE (CTAP)",
        "image": null,
        "address": "P.O. Box 75435 Dar es Salaam",
        "bishop": "Rev. Dr. Onesmo Sambo",
        "email": "ctapsambo@gmail.com",
        "phone": "0715 605999"
    },
    {
        "id": 128,
        "name": "Upendo Stanley Mnai Welfare Ministry",
        "image": null,
        "address": "P.O. Box 45198 Dar es Salaam",
        "bishop": "Upendo Stanley Mnai",
        "email": "",
        "phone": "0718 574000"
    },
    {
        "id": 129,
        "name": "The Salvation Church of All Nations",
        "image": null,
        "address": "S.L.P. 246 Iringa",
        "bishop": "Garasiano Joseph Myinga",
        "email": "",
        "phone": "0789 615782"
    },
    {
        "id": 130,
        "name": "Total Healing Ministries",
        "image": "https://yt3.googleusercontent.com/ytc/AIdro_kabObr2AchENaCBwUKlydkjQayABprh4sZhw2KINrPbA=s900-c-k-c0x00ffffff-no-rj",
        "address": "S.L.P 6562 Mbeya",
        "bishop": "Leonard Lutegama Maboko",
        "email": "",
        "phone": "0754 645672"
    },
    {
        "id": 131,
        "name": "Church of God in Christ",
        "image": null,
        "address": "S.L.P 382 Mbeya",
        "bishop": "Jail Wilson Kasekwa",
        "email": "",
        "phone": "0754 398286"
    },
    {
        "id": 132,
        "name": "Sayuni Prayers’ Mission Pentecostal",
        "image": null,
        "address": "S.L.P 7227 Dar es Salaam",
        "bishop": "Joyce Elieskia Mpungu",
        "email": "",
        "phone": "0714 950429"
    },
    {
        "id": 133,
        "name": "The Pentecostal Stable Christian Church",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRzyXWkT_iGdS895DumvL_jHSygj0AMJl7LIg&s",
        "address": "S.L.P 3491 Mbeya",
        "bishop": "Jumanne John Mwambenja",
        "email": "",
        "phone": "0756 514401"
    },
    {
        "id": 134,
        "name": "Kingdom House International Ministry",
        "image": null,
        "address": "S.L.P 216 Mbeya",
        "bishop": "Samwel Herbert Katsekera",
        "email": "",
        "phone": "0784 591604"
    },
    {
        "id": 135,
        "name": "Bethel Deliverance Center Tanzania",
        "image": null,
        "address": "S.L.P 1783 Dar es Salaam",
        "bishop": "Innocent Ernest Kapenda",
        "email": "",
        "phone": "0652 207949"
    },
    {
        "id": 136,
        "name": "House of God Ministries",
        "image": null,
        "address": "S.L.P 482 Ifakara",
        "bishop": "Alfonce Francis Mlekia",
        "email": "",
        "phone": "0784 482014"
    },
    {
        "id": 137,
        "name": "Gilgal Christian Ministries International",
        "image": null,
        "address": "S.L.P 504 Mwanza",
        "bishop": "Eliab Mathias Sentozi",
        "email": "",
        "phone": "0754 817212"
    },
    {
        "id": 138,
        "name": "The Messenger Ministry",
        "image": null,
        "address": "S.L.P. 1645 Tanga",
        "bishop": "Dee Francis Kusaga",
        "email": "",
        "phone": "0783 171707"
    },
    {
        "id": 139,
        "name": "True Faith Church of God International",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQo3T67ZWxgw3YF1M_4PYW4QSAIneHgyGz7MQ&s",
        "address": "S.L.P 278 Mbeya",
        "bishop": "Amenye Kakamo Mwaikambo",
        "email": "",
        "phone": "0764 195727"
    },
    {
        "id": 140,
        "name": "Pentecoste Original Church in Tanzania",
        "image": null,
        "address": "S.L.P 2066 Mbeya",
        "bishop": "Simon Mwaikuju Bukuku",
        "email": "",
        "phone": "0767 586717"
    },
    {
        "id": 141,
        "name": "The Norbert and Friends Missions",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSJW4QdFCpc_8B0Sb4JES5rQyyDWmRIvOR37w&s",
        "address": "S.L.P 10444 Arusha",
        "bishop": "Norbert Enock Mbwiliza",
        "email": "norbertprojects@gmail.com",
        "phone": "0621 072783"
    },
    {
        "id": 142,
        "name": "International Calvary Fellowship",
        "image": null,
        "address": "S.L.P 263 Tarime",
        "bishop": "Mange’ra Samwel Munyoro",
        "email": "",
        "phone": "0752 735955"
    },
    {
        "id": 143,
        "name": "Narrow Gate Assembly Church",
        "image": null,
        "address": "S.L.P 7355 Moshi",
        "bishop": "Bernard Benedict Temba",
        "email": "",
        "phone": "0715 995538"
    },
    {
        "id": 144,
        "name": "Tanzania Pentecost Mission Church",
        "image": null,
        "address": "S.L.P 7837 Moshi",
        "bishop": "Godfrey Bariki Mtuly",
        "email": "",
        "phone": "0754 055111"
    },
    {
        "id": 145,
        "name": "Evangel Church World",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTo2oIKxUMmoOxvVb1YtYlBYCbZMuTe1roweA&s",
        "address": "S.L.P 1042 Musoma",
        "bishop": "Nashon K. Muttan",
        "email": "",
        "phone": "0659 869643"
    },
    {
        "id": 146,
        "name": "Zion Harvest Gospel Mission of Tanzania",
        "image": null,
        "address": "S.L.P 11170 Mwanza",
        "bishop": "Edward J. Manyanya",
        "email": "",
        "phone": "0698 543033"
    },
    {
        "id": 147,
        "name": "Living stone Church of Tanzania",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQHtHhwXKF62HZ_i9YpMpdtuTuDrIpsKvSIGg&s",
        "address": "S.L.P 160 Bariadi",
        "bishop": "Masalu Washa Mang’ombe",
        "email": "",
        "phone": "0783 487069"
    },
    {
        "id": 148,
        "name": "Christian Gospel Revival Assembly",
        "image": null,
        "address": "S.L.P 403 Kigoma",
        "bishop": "Samwel Zablon Kilibwa",
        "email": "",
        "phone": "0784 539814"
    },
    {
        "id": 149,
        "name": "Pentecostal Ebenezer Assembly Church",
        "image": null,
        "address": "S.L.P 2338 Moshi",
        "bishop": "Geofrey Saliel Minja",
        "email": "",
        "phone": "0754 858314"
    },
    {
        "id": 150,
        "name": "Mwangaza Pentecostal Church",
        "image": "https://i.ytimg.com/vi/OwrYLSeNFw0/hqdefault.jpg",
        "address": "S.L.P 1552 Arusha",
        "bishop": "Leonard James Ngeleja",
        "email": "",
        "phone": "0754 821825"
    },
    {
        "id": 151,
        "name": "Sonshine Ministries of Tanzania",
        "image": "https://static.wixstatic.com/media/a4a1b6_034b6d0a81154aa39c4846aea3160ab8~mv2.png/v1/fit/w_2500,h_1330,al_c/a4a1b6_034b6d0a81154aa39c4846aea3160ab8~mv2.png",
        "address": "S.L.P 246 Usa – River",
        "bishop": "Stephen Chege Wachira",
        "email": "",
        "phone": "0629 950263"
    },
    {
        "id": 152,
        "name": "Patmo Community Prayers Church",
        "image": null,
        "address": "S.L.P 287 Njombe",
        "bishop": "Cyprias Costantin Chuhila",
        "email": "",
        "phone": "0754 054028"
    },
    {
        "id": 153,
        "name": "Calvary Evangelical Assembly",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTvGWAtZ_ZW3xIjzDFQNCTNJk7SVyzg-snuQ&s",
        "address": "S.L.P 72421 Dar es Salaam",
        "bishop": "Hezron Ntizompeba Mgani",
        "email": "",
        "phone": "0754 553973"
    },
    {
        "id": 154,
        "name": "Shalom Gospel Assembly Church",
        "image": null,
        "address": "S.L.P 11764 Dar es Salaam",
        "bishop": "Elias Hassan Mwakaluka",
        "email": "",
        "phone": "0784 278327"
    },
    {
        "id": 155,
        "name": "Highway of Holiness Church Tanzania",
        "image": null,
        "address": "S.L.P Mwanza",
        "bishop": "Eugene Kalisa Murisa",
        "email": "",
        "phone": "0742 407008"
    },
    {
        "id": 156,
        "name": "The Gospel Special Massage Ministry",
        "image": null,
        "address": "S.L.P 4117 Dodoma",
        "bishop": "Majid Salim Ally",
        "email": "",
        "phone": "0752 299704"
    },
    {
        "id": 157,
        "name": "God’s Love Fellowship Church",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQTnJSRQn0C73fWYByYDbWouSIylsIazQte-w&s",
        "address": "S.L.P 123 Dodoma",
        "bishop": "Mallaki Philip Sollo",
        "email": "",
        "phone": "0754 383853"
    },
    {
        "id": 158,
        "name": "Jesus Ark International",
        "image": null,
        "address": "S.L.P 9793 Dar es Salaam",
        "bishop": "Ibrahimu Aron Sabuni",
        "email": "",
        "phone": "0754 585275"
    },
    {
        "id": 159,
        "name": "Christ Laborers Church",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSUvFkOV1t66818zo8ogws3ppRDUkQ_qjFTBw&s",
        "address": "S.L.P 33891 Pwani",
        "bishop": "Vicent Simon Komba",
        "email": "",
        "phone": "0762 460690"
    },
    {
        "id": 160,
        "name": "New Enhakole Assemblies of God",
        "image": null,
        "address": "S.L.P 23208 Dar es Salaam",
        "bishop": "Sabina Nasson Mwaselela",
        "email": "",
        "phone": "0766 552496"
    },
    {
        "id": 161,
        "name": "Universal Church of the Kingdom of God Tanzania",
        "image": null,
        "address": "S.L.P 341339 Dar es Salaam",
        "bishop": "Gilson Carlso Costa",
        "email": "",
        "phone": "0713 500897"
    },
    {
        "id": 162,
        "name": "The Lighthouse Mission Church",
        "image": null,
        "address": "S.L.P 45419 Dar es Salaam",
        "bishop": "David Chomba Kalyat",
        "email": "chombadk@gmail.com",
        "phone": "0654 239333"
    },
    // {
    //     "id": 163,
    //     "name": "The Lighthouse mission Church",
    //     "image": null,
    //     "address": "S.L.P 45419 Dar es Salaam",
    //     "bishop": "David Chomba Kalyat",
    //     "email": "chombadk@gmail.com",
    //     "phone": "0654 239333"
    // },
    {
        "id": 164,
        "name": "Kingdom Mission International Church",
        "image": null,
        "address": "S.L.P 175 Dodoma",
        "bishop": "Juvenal Macumi Kabunduguru",
        "email": "",
        "phone": "0754 482666"
    },
    {
        "id": 165,
        "name": "The Sowers Evangelistic International Church",
        "image": "https://yt3.googleusercontent.com/nwBbG4n8qvzq5wGgqA7rI9ne6OrUqOkSwdTY6JZdWfLG1DSdgOJpt9EC-ZaOeoBU8tQN5gZVvfQ=s900-c-k-c0x00ffffff-no-rj",
        "address": "S.L.P 3142 Mwanza",
        "bishop": "Daniel Mosses Kulola",
        "email": "",
        "phone": "0767 749040"
    },
    {
        "id": 166,
        "name": "Kanisa la Pentekoste Neno la Uzima Tanzania",
        "image": null,
        "address": "S.L.P 124 Manyara",
        "bishop": "Andrew S. Waary",
        "email": "",
        "phone": "0784 533658"
    },
    {
        "id": 167,
        "name": "Pentecoste Free Agape Church",
        "image": null,
        "address": "S.L.P 2655 Dodoma",
        "bishop": "William Abraham Lunguli",
        "email": "",
        "phone": "0679 487944"
    },
    {
        "id": 168,
        "name": "The Voice of Hope Ministries",
        "image": "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjo6esl3xi1b1TLSaXvlyGajBA4mFoVAGnI6w3uB338zSm1StEwSUn2j161A6_fbWy770cQG3jSrwFFZotG4HG7ZrXhAWlz1nsHMEvMyU-HkZLU5x6hp3JCsed_GNrTsj0YHQBIiJEaXJg/s1600-r/vhm-logoooo-300x224.jpg",
        "address": "S.L.P 33091 Dar es Salaam",
        "bishop": "Subira Peter Mitimingi",
        "email": "",
        "phone": "0716 205353"
    },
    {
        "id": 169,
        "name": "Kanisa la Pentekoste Kijitonyama",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTTk85__xGTM9UErnb61cZzGtInhGgtcGm81A&s",
        "address": "S.L.P 5831 Dar es Salaam",
        "bishop": "Methusela John Mpera",
        "email": "",
        "phone": "0767 252563"
    },
    {
        "id": 170,
        "name": "Kanisa la Pentekoste Tanzania",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTrupQt1QkHE8Eo1JvIYkZsgpr27QkoFUNP6g&s",
        "address": "S.L.P 838 Dar es Salaam",
        "bishop": "Phanuel Juma Shekihiyo",
        "email": "",
        "phone": "0755 631588 | 0658 904845"
    }
];